import React from "react";
import { AuthProvider, useAuth } from "../software/AuthContext";
import Login from "../components/software/Login";
import Dashboard from "../components/software/Dashboard";
import Portal from "../components/software/Portal";
import { Loader2 } from "lucide-react";

function Gate() {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center bg-[#FAFCFD]"><Loader2 className="h-6 w-6 animate-spin text-sky-600" /></div>;
  if (!user) return <Login />;
  return user.role === "client" ? <Portal /> : <Dashboard />;
}

export default function Software() {
  return <AuthProvider><Gate /></AuthProvider>;
}
